import { render } from "./MaskedCardLabel.vue?vue&type=template&id=3c88c20c&lang=pug"
import script from "./MaskedCardLabel.vue?vue&type=script&lang=js"
export * from "./MaskedCardLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__